import './trial.css'
import './static/calendar-crossed.svg'
import './static/thumbs-up.svg'
